/** Focus (and scroll into view) the first existing element by id. Opens mobile keyboard for inputs. */
export function focusFirstInvalidField(ids: Array<string | null | undefined>): void {
  for (const id of ids) {
    if (!id) continue;
    const el = document.getElementById(id);
    if (!el) continue;
    el.focus();
    el.scrollIntoView({ block: "center", behavior: "smooth" });
    return;
  }
}
